import {
  BoelsGenericState,
  BoelsPointOfServiceStock,
  PointOfServiceStock,
} from '@boels/models';
import { Action, createReducer, on } from '@ngrx/store';
import {
  findProductStock,
  findProductStockFailure,
  findProductStockSuccess,
  resetSelectedProductStock,
  setSelectedProductStock,
} from '../actions/product-stock.actions';

export interface ProductStockState extends BoelsGenericState {
  stores: PointOfServiceStock[];
  selected?: {
    query: string;
    store: BoelsPointOfServiceStock;
  };
  errorMessage?: string;
}

export const initialState: ProductStockState = {
  stores: [],
  selected: undefined,
  loading: false,
  success: false,
  error: false,
  errorMessage: undefined,
};

const productStockReducer = createReducer(
  initialState,

  on(findProductStock, (state: ProductStockState) => ({
    ...state,
    loading: true,
    success: false,
    error: false,
  })),

  on(findProductStockSuccess, (state: ProductStockState, { stores }) => ({
    ...state,
    stores: stores,
    loading: false,
    success: true,
    error: false,
  })),

  on(
    setSelectedProductStock,
    (state: ProductStockState, { query, selectedProductStock }) => ({
      ...state,
      selected: {
        query: query,
        store: selectedProductStock,
      },
      loading: false,
      success: true,
      error: false,
    }),
  ),

  on(resetSelectedProductStock, (state: ProductStockState) => ({
    ...state,
    selected: undefined,
    loading: false,
    success: true,
    error: false,
  })),

  on(findProductStockFailure, (state: ProductStockState, { errorMessage }) => ({
    ...state,
    loading: false,
    success: false,
    error: true,
    errorMessage: errorMessage,
  })),
);

export function reducer(state: ProductStockState | undefined, action: Action) {
  return productStockReducer(state, action);
}
